import { forwardRef, ReactNode, SVGAttributes } from 'react'

export type IconSystemColor = 'iport' | 'dark' | 'grey'

const SystemColors: Record<IconSystemColor, string> = {
	dark: '#292424',
	iport: '#568DFE',
	grey: '#B0B2B9'
} as const

interface SystemIconTemplateProps extends SVGAttributes<SVGElement> {
	children: ReactNode
	size?: string | number
	systemColor?: 'iport' | 'dark' | 'grey'
}

export const SystemIconTemplate = forwardRef<SVGSVGElement, SystemIconTemplateProps>((props, ref) => {
	const { children, size = 24, systemColor = 'dark', color, ...rest } = props

	return (
		<svg
			ref={ref}
			width={size}
			height={size}
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			color={color ? color : SystemColors[systemColor]}
			{...rest}
		>
			{children}
		</svg>
	)
})
